module.exports = __webpack_public_path__ + "img/fontUnderlineWhite.e882b49d.svg";